/* Appel de l'extension navigateur « OphtaPilot ↔ Doctipro » depuis la page (window.postMessage via le pont). */
import { useEffect, useState } from 'react';

export const extensionVersion = () => document.documentElement.getAttribute('data-ophtapilot-ext') || '';

export const appelerExtension = (action, payload = {}, timeoutMs = 10000) => new Promise((resolve) => {
  if (!extensionVersion()) { resolve({ ok: false, erreur: 'Extension OphtaPilot non détectée dans ce navigateur.' }); return; }
  const requestId = Math.random().toString(36).slice(2) + Date.now().toString(36);
  const timer = setTimeout(() => { window.removeEventListener('message', onMsg); resolve({ ok: false, erreur: 'L\'extension ne répond pas (rechargez la page).' }); }, timeoutMs);
  function onMsg(ev) {
    if (ev.source !== window || ev.origin !== window.location.origin) return;
    const d = ev.data;
    if (!d || d.type !== 'ophtapilot-ext-response' || d.requestId !== requestId) return;
    clearTimeout(timer);
    window.removeEventListener('message', onMsg);
    const { type, requestId: _r, ...reste } = d;
    resolve(reste);
  }
  window.addEventListener('message', onMsg);
  window.postMessage({ type: 'ophtapilot-ext-request', requestId, action, payload }, window.location.origin);
});

export const useExtensionDoctipro = () => {
  const [version, setVersion] = useState(extensionVersion);
  useEffect(() => {
    const onMsg = (ev) => { if (ev.source === window && ev.data?.type === 'ophtapilot-ext-ready') setVersion(ev.data.version || '1'); };
    window.addEventListener('message', onMsg);
    const t = setTimeout(() => setVersion(extensionVersion()), 1500);
    return () => { window.removeEventListener('message', onMsg); clearTimeout(t); };
  }, []);
  return version;
};
